module.exports = __webpack_public_path__ + "static/covidbg-4e95b010710d3a56bde5e04d499fadb7.svg";